import React from 'react';
import InvalidIcon from '@mui/icons-material/WarningRounded';

import FormElemLabel from './FormElemLabel';
import ErrorLabel from './FormErrorMessages/ErrorLabel';
import { formElemHasError } from '../helpers/getClassName';
import '../Forms.css';
import InstructionsLabel from '@3.0/Forms/InstructionsLabel/InstructionsLabel';

function FormElementContainer({
  containerProps = {},
  children,
  errors = {},
  inputName,
  label = '',
  required = false,
  showErrorMessageBelow = false,
  hideWarningLabelOnFormElement = false,
  instructionsLabel = '',
  labelProps = {},
}) {
  const hasError = formElemHasError(inputName, errors);

  return (
    <div {...containerProps}>
      {label.length > 0 && (
        <FormElemLabel required={required} {...labelProps}>
          {label}
        </FormElemLabel>
      )}
      {instructionsLabel && <InstructionsLabel label={instructionsLabel} />}
      {!showErrorMessageBelow && <ErrorLabel errors={errors} name={inputName} />}
      <div className={`black-bird-form relative ${showErrorMessageBelow ? 'mb1' : ''}`}>
        {children}
        {!hideWarningLabelOnFormElement && (
          <InvalidIcon
            className={'error-red opacity absolute transition ' + (hasError ? '0-100' : 'o-0')}
            style={{
              display: hasError ? 'block' : 'none',
              bottom: 9,
              right: 4,
            }}
          />
        )}
      </div>
      {showErrorMessageBelow && <ErrorLabel errors={errors} name={inputName} />}
    </div>
  );
}

export default FormElementContainer;
